import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[uppercase]",
  host: { "(blur)": "onBlur($event)" },
})
export class UppercaseDirective {
  constructor(
    public model: NgControl,
    public ele: ElementRef,
    public renderer: Renderer2
  ) {}

  onBlur($event) {
    const upperValue = this.ele.nativeElement.value.toUpperCase();
    if (this.ele.nativeElement.value !== upperValue) {
      this.renderer.setProperty(this.ele.nativeElement, "value", upperValue);
      this.model.viewToModelUpdate(upperValue);
      this.model.control.setValue(upperValue);
    }
  }
}
